<template>
  <section class="zone-selection t-text" :class="zoneTeaserUi.gametype">
    <t-container>
      <div class="zone-layout">
        <!-- render the teasers -->
        <c-zone-tournament-item
          @onGoToZone="onZoneSelect"
          class="zone-item"
          :zoneSelectionUi="zoneTeaserUi"
          :language="$i18n.locale"
        ></c-zone-tournament-item>
      </div>
    </t-container>
  </section>
</template>

<script setup lang="ts">
/**
 * Renders only the teasers for the zone ZoneOverviewView.
 */
import { useRouter } from 'vue-router'
import CZoneTournamentItem from '@/components/CZoneTournamentItem.vue'
import { TOURNAMENT_TYPE, TournamentTypeToName } from '@/model/TournamentType'
import { ZoneSelectionUi } from '@/model/ZoneSelection'
import { track } from '@/lib/track'

defineProps<{ zoneTeaserUi: ZoneSelectionUi }>()
const emit = defineEmits(['close'])
const router = useRouter()

function onZoneSelect(tournamentType: TOURNAMENT_TYPE) {
  router.push(`/tournaments/${TournamentTypeToName[tournamentType]}`)
  track({
    id: 'zoneSelection',
    elem: 'zone-clicked',
    data: tournamentType,
  })
}
</script>

<style lang="less">
// TODO: Move into dedicated file

.zone-selection {
  width: 100%;
  &.ska {
    // background-color: rgb(130, 189, 130);
  }
  &.rom {
    // background-color: rgb(243, 178, 178);
  }
  &:last-child {
    // border-bottom: none;
  }
}

.zone-layout {
  // display: flex;
  // justify-content: space-around;
  // flex-direction: column;

  .zone-item {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
